<template>
    <div class="modal-inline-container">
        <div ref="modal">
            <div :class="`modal${cssClass ? (` modal--${cssClass}`) : ''}`">
                <div class="modal__alert" v-if="$slots.alert">
                    <slot name="alert"></slot>
                </div>
                <div class="modal__header" v-if="$slots.header">
                    <slot name="header"></slot>
                </div>

                <div class="modal__body">
                    <slot name="body"></slot>
                </div>

                <div class="modal__footer" v-if="$slots.footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GLightbox from 'glightbox/src/js/glightbox';

    export default {
        name: 'Modal',
        props: {
            closable: { type: Boolean, default: true },
            cssClass: { type: String, default: '' },
            modelValue: { type: Boolean, default: false },
        },
        watch: {
            modelValue(value) {
                if (!this.modal) return;

                value ? this.modal.open() : this.modal.close();
            },
        },
        mounted() {
            const modalWrapperContainer = this.$refs.modal.parentNode;

            this.modal = GLightbox({
                closeOnOutsideClick: this.closable,
                closeButton: this.closable,
                keyboardNavigation: this.closable,
                touchNavigation: false,
                elements: [
                    {
                        'href': modalWrapperContainer.id,
                        'type': 'inline',
                        'width': 'auto',
                        'height': 'auto',
                    },
                ],
                onOpen: () => {
                    this.$emit('update:modelValue', true);
                    this.$emit('show', this.modal);
                    this.moveCloseButtonInside();
                },
                onClose: () => {
                    this.moveElement(modalWrapperContainer, this.$refs.modal);
                    this.$emit('update:modelValue', false);
                    this.$emit('close', this.modal);
                },
                afterSlideLoad: (slide) => {
                    const slideMedia = slide.querySelector('.gslide-media');
                    this.moveElement(slideMedia, this.$refs.modal);
                }
            });

            if (this.modelValue) {
                this.modal.open();
            }
        },
        methods: {
            moveElement(target, source) {
                target.innerHTML = '';
                target.appendChild(source);
            },
            moveCloseButtonInside() {
                const closeBtn = document.querySelector('.gclose');
                const modalContainer = document.querySelector('.gslider');
                if (closeBtn && modalContainer) {
                    modalContainer.appendChild(closeBtn);
                }
            }
        }
    }
</script>
